import React, { useEffect } from "react";
import { useUserInfo } from "../../../common/user-context";
import { useState } from "react";
import CardLoaderComponent from "../../../CardLoaderComponent";
import { Tooltip } from "@deere/fuel-react";

const PickupCarrierPerformanceReport = () => {
  const { userData } = useUserInfo();
  const [averagePickUpTime12Months, setAveragePickUpTime12Months] = useState();
  const [averagePickUpTime30Days, setAveragePickUpTime30Days] = useState();
  const [pickUpDesc, setPickUpDesc] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      if (userData.internal) {
        setAveragePickUpTime12Months(userData.averagePickUpTime12Months);
        setAveragePickUpTime30Days(userData.averagePickUpTime30Days);
        setPickUpDesc(" - (All Forwarders)");
        setIsLoading(false);
      } else if (userData.forwarder) {
        setAveragePickUpTime12Months(
          userData.averagePickUpTime12MonthsForwarder
        );
        setAveragePickUpTime30Days(userData.averagePickUpTime30DaysForwarder);
        setIsLoading(false);
      }
    }
  }, [userData]);

  return (
    <>
      {isLoading && (
        <CardLoaderComponent
          desc="pickup performance"
          subtitle="This will take a couple seconds"
        />
      )}
      {!isLoading && (
        <div className="w-full">
          {/* Widget Title */}
          <div className="mb-4 flex justify-between items-center">
            <h2 className="text-lg font-semibold text-gray-800">
              Pickup Performance{" "}
              <Tooltip title={userData.descr}>
                <span className="text-sm font-normal text-gray-600">{pickUpDesc}</span>
              </Tooltip>
            </h2>
          </div>

          {/* Content Area */}
          <div className="min-h-[200px]">
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 rounded-md">
                <span className="font-medium text-black">
                  Orders in Time{" "}
                  <span className="font-normal">(Last 12 Months)</span>
                </span>
                <span
                  className={`text-black font-semibold ${
                    averagePickUpTime12Months > 90
                      ? "text-green-600"
                      : averagePickUpTime12Months > 50
                      ? "text-yellow-400"
                      : "text-red-600"
                  }`}
                >
                  {averagePickUpTime12Months}%
                </span>
              </div>
              
              <div className="flex items-center justify-between p-2 rounded-md">
                <span className="font-medium text-black">
                  Orders in Time{" "}
                  <span className="font-normal">(Last 30 Days)</span>
                </span>
                <span
                  className={`text-black font-semibold ${
                    averagePickUpTime30Days > 90
                      ? "text-green-600"
                      : averagePickUpTime30Days > 50
                      ? "text-yellow-400"
                      : "text-red-600"
                  }`}
                >
                  {averagePickUpTime30Days}%
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PickupCarrierPerformanceReport;
